import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Box, Pagination} from '@mui/material';
import { getBuildings, getSupervisors, openModal} from '../actions';
import {Filters, Layout, PageHeader} from '../components';
import {usePagination} from '../utils/utilities';
import useFilters from '../utils/useFilters';
import SupervisorsTable from '../components/CustomTables/SupervisorsTable';
import { getAllElevators } from '../actions/elevatorsActions';

const Supervisors = () => {
  const dispatch = useDispatch();
  const {supervisors, supervisorsLoading} = useSelector(s => s.supervisors);
  const pagination = usePagination(supervisors);
  const filters = useFilters(val => dispatch(getSupervisors(val)));

  const onAddSupervisor = () => {
    dispatch(openModal('AddSupervisorModal'));
  };

  useEffect(() => {
    pagination.onChange(null, 1);
  }, [supervisors]);

  useEffect(() => {
    dispatch(getSupervisors());
    dispatch(getAllElevators()); 
  }, []);

  return (
    <Layout>
      <PageHeader onAdd={onAddSupervisor} title="Elevator Supervisors" />
      <Filters withSearch {...filters} m="1rem !important" />
      <SupervisorsTable supervisors={pagination.dataToShow} loading={supervisorsLoading} />
      {!!pagination.count && pagination.count > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination {...pagination} />
        </Box>
      )}
    </Layout>
  );
};

export default Supervisors;
